<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <md-field :class="{ 'md-invalid': !nameValid }">
                <label>Guest #{{ sequenceNumber + 1 }} name</label>
                <md-input required :value="capitalize(name)" :readonly="readonly" @input="onNameChanged"></md-input>
                <span class="md-error">{{ 'Name has invalid format' }}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': !emailValid }">
                <label>email </label>
                <md-input :value="email" :readonly="readonly" @input="onEmailChanged"></md-input>
                <span class="md-error">{{ 'Email has invalid format' }}</span>
            </md-field>
            <md-field :class="{ 'md-invalid': !phoneValid }">
                <label>phone</label>
                <md-input :value="phone" :readonly="readonly" @input="onPhoneChanged"></md-input>
                <span class="md-error">{{ 'Phone has invalid format' }}</span>
            </md-field>
        </div>
    </div>
</template>

<script>
    export default {
        name: "GuestData",
        props: {
            name: {
                type: String,
                required: true,
            },
            email: {
                type: String,
                required: false,
            },
            phone: {
                type: String | Number,
                required: true,
            },
            sequenceNumber: {
                type: Number,
                required: true,
            },
            readonly: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                nameValid: true,
                emailValid: true,
                phoneValid: true,
            };
        },
        methods: {
                capitalize(value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
            onNameChanged(name) {
                this.nameValid = this.validateName(name);
                if (!this.nameValid) {
                    return;
                }
                this.onChanged({ name });
            },
            onEmailChanged(email) {
                this.emailValid = this.validateEmail(email);
                if (!this.emailValid) {
                    return;
                }
                this.onChanged({ email });
            },
            onPhoneChanged(phone) {
                this.phoneValid = this.validatePhone(phone);
                if (!this.phoneValid) {
                    return;
                }
                this.onChanged({ phone });
            },
            validateName(value) {
                return /[a-zA-Z ]+/.test(value);
            },
            validateEmail(value) {
                return /.+@.+/.test(value);
            },
            validatePhone(value) {
                return /\d/.test(value);
            },
            onChanged(data) {
                this.$emit('changed', {
                    name: data.name || this.name,
                    email: data.email || this.email,
                    phone: data.phone || this.phone,
                    seq: this.sequenceNumber,
                });
            },
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/bookings/deals/GuestData.vue